import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import QDataTableHeader from '../../../components/datatables/base/QDataTableHeader.vue';
import { useGetResource } from '../../shared/composables/api/useGetResource';
import { getAgencyCentricMetric, getRecruitCentricMetrics, getWriterCentricMetrics, getMetricValues, Filters } from '../api';
import AoFilters from '../components/AoFilters.vue';
import AoAgencyDataTable from '../components/AoAgencyDataTable.vue';
import AoRecruitsDataTable from '../components/AoRecruitsDataTable.vue';
import AoWriterDataTable from '../components/AoWriterDataTable.vue';
import Loader from '../components/Loader.vue';
import AoMetricDataTable from '../components/AoMetricDataTable.vue';
import { ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'AoRecruitingDashboard',
  props: {
  agentCode: {
    type: String,
    required: true,
  },
},
  setup(__props) {

const props = __props



const filters = ref<Filters>({
  search: '',
})

const { data: metricData, isLoading: metricDataLoading } = useGetResource(getMetricValues, computed(() => ({
  agentCode: props.agentCode,
})))

// Excluded for now. We want to show blue boxes this is why we need full data. Actually, it would be better to return
// these data from API
// const mergeWithMetricData = function<T extends Record<'AgentCode', any>>(arr: T[] | undefined) {
//   if (!arr) { return undefined }
//   if (!metricData.value) { return undefined }

//   return mergeOn(arr, metricData.value, 'AgentCode')
// }

const { data: agencyData, isLoading: agencyDataLoading } = useGetResource(getAgencyCentricMetric, computed(() => ({
  agentCode: props.agentCode,
})))

const { data: recruitsData, isLoading: recruitsDataLoading } = useGetResource(getRecruitCentricMetrics, computed(() => ({
  agentCode: props.agentCode,
})))

const { data: writesData, isLoading: writesDataLoading } = useGetResource(getWriterCentricMetrics, computed(() => ({
  agentCode: props.agentCode,
})))

const prepareData = <T extends { AgentName: string, [key: string]: any }[]>(arr: T | undefined) => {
  if (!arr) { return arr }
  return arr
    .map((row) => {
      Object.keys(row).forEach((key: string) => {
        const v = row[key]
        if (typeof v === 'number') {
          row[key] = Number(v.toFixed(2))
        }
      })
      return row
    })
    .filter((item) => {
      return item.AgentName.toLocaleLowerCase().includes(filters.value.search.toLocaleLowerCase())
    }) as T
}

return { __sfc: true,props, filters, metricData, metricDataLoading, agencyData, agencyDataLoading, recruitsData, recruitsDataLoading, writesData, writesDataLoading, prepareData, QDataTableHeader, AoFilters, AoAgencyDataTable, AoRecruitsDataTable, AoWriterDataTable, Loader, AoMetricDataTable }
}

})